import z from 'zod';

import { Draft } from '../../common';
import { getSchema as getOrgSchema } from '../orgSchema';
import { IDIRecord } from './diInterface';
import { getSchema as getDiSchema } from './diSchema';
import { IFieldErrors, ValidationError } from '../../validation';


export const getSchema = (update: Draft<IDIRecord>, preparing: boolean,type:string) => {
  const orgSchema = getOrgSchema(update.org || {}, preparing,type);
  const diSchema = getDiSchema(update.di || {});
    return (
        z.object({
            org: orgSchema,
            di: diSchema
        }) );
};


export const validate = (request: Draft<IDIRecord>, preparing: boolean,type: string | 'di') => {
  // console.log('diRecordSchema: request :',request);
  const schema = getSchema(request, preparing,type);
  try {
    const validated = schema.parse(request);
    return {
      ...validated
    };
  } catch (error: any) {
    console.log('diRecordSchema: error :',error);
    console.log('-------DIRECORD SCHEMA ZOD ERROR-----');
    if (error instanceof z.ZodError) {
      const errors: IFieldErrors = error.format();
      throw new ValidationError(errors);
    }
    throw new Error(error?.message || '');
  }
};